export default function () {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="11.5" r="11.5" fill="white" />
            <circle cx="12" cy="11.5" r="7.5" fill="#F4C984" />
        </svg>
    );
}
